import SceButton from "../../../../Common/CommonComponents/sceButton";
import ReactHtmlParser from 'react-html-parser';
import classes from './budaTermsCondition.scss';
import Checkbox from "../../PB/Presentational/PbCheckbox";
import { getLocalizedStrings } from "../../../centralizedLocalizedString";

class BudaTermsCondition extends React.Component {

  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings('BaAlerts');
    this.state = {
      showFullContent: false,
      buttonValue: this.strings.budaShowMore,
      buttonIcon: 'downArrow',
      checkboxSelectedOption: false,
      selectedOptionIcon: false,
      isCheckboxClicked:this.props.isTnCSelected? this.props.isTnCSelected:false,
    };
  }

  componentDidMount() {
    let contentType='BUDGET_ASSISTANT_TNC';
    app.contentService.getContent(contentType).then((response) => {
      this.setState({ tncData: response[0].body });
    }, (error) => {
      app.logger.getLogger().info('error error::' + JSON.stringify(error));
    });
  }

  showMoreLess = () => {
    let showFullContent = !this.state.showFullContent;
    let buttonValue = (showFullContent) ? this.strings.budaShowLess : this.strings.budaShowMore;
    let buttonIcon = (showFullContent) ? 'upArrow' : 'downArrow';
    this.setState({ showFullContent: showFullContent, buttonValue: buttonValue, buttonIcon: buttonIcon });
  }
  handleCheckClick=async(e)=> {
    this.setState({ isCheckboxClicked: !this.state.isCheckboxClicked }, ()=>{
      this.props.handleTermsCallback(this.state.isCheckboxClicked);
    });
}

printTnC() {
    var printWindow = window.open("", "", "left=0,top=0,width=800,height=500,scrollbars=1");
    var printContents = this.state.tncData;
    printWindow.document.write(printContents);
    printWindow.document.close();// necessary for IE >= 10
    printWindow.focus(); // necessary for IE >= 10
    setTimeout(() => {
      printWindow.print();
      !app.appUtil.detectMobile()? printWindow.close() : null;
    }, 1000);

  }

  render() {
    
    const tNcHeader = this.strings.baTNCHeaderText;
    const tNcContent = this.state.tncData ? (this.state.tncData).match(/<p>([^`]*?)<\/p>/g) : '' ;
    return (
      <div className={classes.sceOutgTNC}>
        <div className={classes.scePrintLinkContainer}>
         <a className={classes.scePrintLink} onClick={() => this.printTnC()} href="javascript::void(0)" > {this.strings.budaTnCPrint} </a>
        </div>
        <div className={(this.state.showFullContent) ? classes.sceTNCFullContent : classes.sceTNCLessContent}>
            <div className={[classes.sceTNCConten,classes.sceTNCHeader].join(' ')}>
                {tNcHeader}
            </div>
            <div className={classes.sceTNCContent}>
                {ReactHtmlParser(tNcContent)}  
            </div>         
        </div>
        {(!this.state.showFullContent && !this.props.hideGradientOpacity) ?
          <div className={classes.gradientContainer}>
            <div className={classes.gradientOpacity} />
          </div> : null}
        <div className={classes.ShowMore}>
          <SceButton value={this.state.buttonValue} iconType={this.state.buttonIcon} onClick={this.showMoreLess} /> 
        </div>
        <div className={this.props.showCheckboxError?classes.showErrorBorder:''}>
        <Checkbox type={"TermCheckBox"} className={classes.checkBoxContainer} id={'cpc_outg_tnc'} selectedOptions={this.state.isCheckboxClicked}
          selectedOptionIcon={this.props.tncChecked} options={this.strings.budaTnCRead} handleClick={(event) => this.handleCheckClick(event)} /> 
        </div>
        </div>
    );
  }
}
export default BudaTermsCondition;


BudaTermsCondition.dafaultProps={
  hasCheckboxError:false,
  isCheckboxDisabled:false,
  hideGradientOpacity:false,
};